import { useSelector } from "react-redux";
import { RootState } from "../store";
import {
  MyCustomerApiRequest,
  useGetMyCustomersQuery,
} from "../store/services/customerService";

export function useMyCustomers(options?: MyCustomerApiRequest) {
  const selectedUserId = useSelector(
    (state: RootState) => state.user.selectedUserId
  );
  return useGetMyCustomersQuery({
    userId: selectedUserId ?? undefined,
    customerType: options?.customerType,
    customerGroupNo: options?.customerGroupNo,
  });
}
